import { environment } from "../../shared/utils/enum";
export const envConfig = {
  REACT_APP_ENVIRONMENT_NAME: environment.rollout,
  REACT_APP_NAME: "$npm_package_name",
  REACT_APP_VERSION: "$npm_package_version",
  REACT_APP_API_URL: "url api rollout",
};
